import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as IconComponents from "../icons";
import { wrapperClasses } from "../ListItemContent";
import { Checkbox } from "../inputs/Checkbox";
import { useId } from "@floating-ui/react";
import classNames from "classnames";
export const ListboxOption = (props) => {
    const listItemContentProps = Object.assign(Object.assign({}, props.option), { isActive: props.isActive, isSelected: props.isSelected });
    const listItemContent = props.renderListItemContent(listItemContentProps);
    return (_jsx("li", Object.assign({ role: "option", "aria-selected": props.isActive }, props.itemProps, { className: classNames("outline-none", props.isActive && [
            "outline-2",
            "outline-offset-[-2px]",
            "outline-dashed",
            "outline-general-yellow-primary",
            "dark:outline-general-yellow-primary-darkmode",
        ]), tabIndex: -1, onClick: () => { var _a; return (_a = props.selectOption) === null || _a === void 0 ? void 0 : _a.call(props, props.option); }, onFocus: (e) => e.stopPropagation(), onKeyDown: (event) => {
            var _a;
            if (["Enter", "Space"].includes(event.code)) {
                (_a = props.selectOption) === null || _a === void 0 ? void 0 : _a.call(props, props.option);
            }
            if (event.code === "Escape") {
                event.stopPropagation();
                props.closeListbox();
            }
        }, id: useId(), children: _jsx("div", { className: wrapperClasses(), children: props.isMultiple ? (_jsxs(_Fragment, { children: [!props.hideCheckmark && (_jsx(Checkbox, { isChecked: props.isSelected, className: "pointer-events-none", tabIndex: -1, label: "" })), listItemContent] })) : (_jsxs(_Fragment, { children: [listItemContent, props.isSelected && !props.hideCheckmark && (_jsx(IconComponents.CheckIcon, { color: "text-link" }))] })) }) }), props.index));
};
//# sourceMappingURL=ListboxOption.js.map